<template>
 <div></div>
</template>
<script>

  export default {
    name: "base-nav",
    props: {
      containerClasses: {
        type: [String, Object, Array],
        default: 'container-fluid'
      },
    },
  };
</script>
<style>
</style>
